'use client';

import { useCallback, useEffect } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Auth } from '@/components/auth/auth';
import { usePopup } from '@/hooks/use-popup';
import { WithLocale } from '@/types/platform-data';

import HeaderDesktop from './header.desktop';
import HeaderMobile from './header.mobile';
import { HeaderPopupKeys } from './header.types';

export default function HeaderClient(props: WithLocale<{ isCalendar?: boolean }>) {
    const params = useSearchParams();
    const token = params.get('token');
    const path = usePathname();
    const router = useRouter();

    const { isVisible, openPopup, closePopup } = usePopup({
        [HeaderPopupKeys.auth]: false,
        [HeaderPopupKeys.navbar]: false,
    });

    useEffect(() => {
        if (token) {
            openPopup(HeaderPopupKeys.auth);
        }
    }, [token]);

    const closeAuthPopup = useCallback(() => {
        closePopup(HeaderPopupKeys.auth);
        router.push(path);
    }, [closePopup, path, router]);

    const closeModalByKey = useCallback(
        (key: HeaderPopupKeys) => {
            closePopup(key);
        },
        [closePopup],
    );

    const openModalByKey = useCallback(
        (key: HeaderPopupKeys) => {
            openPopup(key);
        },
        [openPopup],
    );

    return (
        <>
            <HeaderDesktop
                onClose={closeAuthPopup}
                isVisible={isVisible}
                onOpen={openModalByKey}
                isCalendar={props.isCalendar}
                country={props.country}
                lang={props.lang}
            />
            <HeaderMobile
                isVisible={isVisible}
                onClose={closeModalByKey}
                onOpen={openModalByKey}
                isCalendar={props.isCalendar}
                country={props.country}
                lang={props.lang}
            />
            {isVisible.auth && <Auth lang={props.lang} isOpened={isVisible.auth} onClose={closeAuthPopup} />}
        </>
    );
}
